// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PopupLink__container-a1ca7c {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  padding: 12px 24px;
  text-decoration: none;
  cursor: pointer;
}

.PopupLink__container-a1ca7c:hover {
  background-color: var(--base-17);
}

.PopupLink__container-a1ca7c:focus-visible {
  background-color: var(--base-17);
}

.PopupLink__container-a1ca7c:active {
  background-color: var(--base-30);
}

.PopupLink__icon-acc1f7 {
  fill: var(--brand-primary-40);
}

.PopupLink__title-b2aed8 {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--brand-primary-40);
  margin-inline-start: 24px;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/PopupLink/PopupLink.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,8BAAA;EACA,yBAAA;AACF","sourcesContent":[".container {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  padding: 12px 24px;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.container:hover {\n  background-color: var(--base-17);\n}\n\n.container:focus-visible {\n  background-color: var(--base-17);\n}\n\n.container:active {\n  background-color: var(--base-30);\n}\n\n.icon {\n  fill: var(--brand-primary-40);\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--brand-primary-40);\n  margin-inline-start: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PopupLink__container-a1ca7c`,
	"icon": `PopupLink__icon-acc1f7`,
	"title": `PopupLink__title-b2aed8`
};
module.exports = ___CSS_LOADER_EXPORT___;
